var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7411 5.05212C15.0863 5.49444 15.0863 6.09157 14.7411 6.53318C13.6539 7.92364 11.0455 10.7866 8.00011 10.7866C4.95475 10.7866 2.34631 7.92364 1.2591 6.53318C1.09116 6.32139 1 6.06084 1 5.79265C1 5.52446 1.09116 5.26391 1.2591 5.05212C2.34631 3.66166 4.95475 0.798706 8.00011 0.798706C11.0455 0.798706 13.6539 3.66166 14.7411 5.05212V5.05212Z",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00011 7.93299C9.20664 7.93299 10.1847 6.97476 10.1847 5.79273C10.1847 4.61069 9.20664 3.65247 8.00011 3.65247C6.79358 3.65247 5.81549 4.61069 5.81549 5.79273C5.81549 6.97476 6.79358 7.93299 8.00011 7.93299Z",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.08a64d28c8fd1352d095163b496dc287.svg";
export { ForwardRef as ReactComponent };